import { VoucherOcr } from "~/application/types";
import { Card } from "~/components/Card";
import { EmptyState } from "~/components/EmptyState";
import { Flex } from "~/components/Flex";
import { Text } from "~/components/Text";
import { LazyList } from "~/components/LazyList";
import { Spinner } from "~/components/Spinner";
import { Col } from "~/components/Grid";

interface VoucherContainerProps {
  data?: VoucherOcr[];
  isLoading?: boolean;
  isError?: boolean;
  onRetry?: () => void;
}

export function VoucherContainer({ data, isLoading, isError, onRetry }: VoucherContainerProps) {
  return (
    <Card>
      <Col css={{ padding: "$4" }}>adasdsads</Col>
    </Card>
  );
}
